import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { RunHistory } from '@frontend/app/containers/Projects/AutomationPage/FlexAutomationPage/RunHistory';
import { IShopifyCredentials, useGetOfferByIdQuery } from '../hooks';
import { UserInfoInput } from '../types/globalTypes';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/shadcn/components/ui/tabs';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shadcn/components/ui/tooltip';
import { RefreshEditOfferPage } from './RefreshEditOfferPage';
import { EmailAutomations } from '../components/EmailAutomations/EmailAutomations';

interface IProps {
  baseUri: string;
  shopifyCredentials: IShopifyCredentials;
  profile: UserInfoInput;
  allowedDomains: string[];
}

function OfferSettingsPage({
  baseUri, shopifyCredentials, profile, allowedDomains
}: IProps) {
  const history = useHistory();
  const location = useLocation();
  const { offerId } = useParams<{ offerId: string }>();
  const offerQuery = useGetOfferByIdQuery({
    variables: {
      id: Number(offerId),
    },
  });
  const { offer } = offerQuery?.data || {};
  // Get current tab from URL or default to 'offer-settings'
  const getCurrentTab = () => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('tab') || 'offer-settings';
  };

  // Update URL when tab changes
  const handleTabChange = (value: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', value);
    history.replace({
      ...location,
      search: searchParams.toString(),
    });
  };

  return (
    <TooltipProvider>
      <div className="flex h-screen p-4">
        <Tabs
          value={getCurrentTab()}
          onValueChange={handleTabChange}
          orientation="vertical"
          className="flex w-full"
        >
          <TabsList className="flex flex-col gap-4 h-full w-64 bg-grey-1 p-0 rounded-none justify-start">
            <TabsTrigger
              value="offer-settings"
              className="w-full justify-start p-4 text-left text-sm font-normal rounded-xl text-grey-6 hover:bg-grey-2 data-[state=active]:bg-grey-2"
            >
              Offer Settings
            </TabsTrigger>
            {/* <TabsTrigger
            value="email-template"
            className="w-full justify-start p-4 text-left text-sm font-normal rounded-xl text-grey-6 hover:bg-grey-2 data-[state=active]:bg-grey-2"
          >
            Email Template
          </TabsTrigger> */}
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="w-full">
                  <TabsTrigger
                    value="automation"
                    className="w-full justify-start p-4 text-left text-sm font-normal rounded-xl text-grey-6 hover:bg-grey-2 data-[state=active]:bg-grey-2 disabled:cursor-not-allowed disabled:opacity-50"
                    disabled={offer?.expired}
                  >
                    Automation
                  </TabsTrigger>
                </div>
              </TooltipTrigger>
              {offer?.expired && (
                <TooltipContent className="bg-grey-0 text-grey-6 shadow-lg border border-gray-200 rounded-md px-3 py-2 font-medium">
                  Automation is disabled for expired offers
                </TooltipContent>
              )}
            </Tooltip>
            <TabsTrigger
              value="run-history"
              className="w-full justify-start p-4 text-left text-sm font-normal rounded-xl text-grey-6 hover:bg-grey-2 data-[state=active]:bg-grey-2"
            >
              Run History
            </TabsTrigger>
          </TabsList>

          <div className="flex-1 px-6 bg-background">
            <TabsContent value="offer-settings" className="mt-0">
              <RefreshEditOfferPage
                shopifyCredentials={shopifyCredentials}
                baseUri={baseUri}
                allowedDomains={allowedDomains}
                profile={profile}
              />
            </TabsContent>

            {/* <TabsContent value="email-template" className="mt-0">
            <EmailTemplatesContainer programId={programId} offerSource={offerSource} isStaOffer />
          </TabsContent> */}

            <TabsContent value="automation" className="mt-0">
              <EmailAutomations offerId={offerId} baseUri={baseUri} />
            </TabsContent>

            <TabsContent value="run-history" className="mt-0">
              <RunHistory projectId={Number(offerId)} baseUri={baseUri} isStaOffer />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </TooltipProvider>
  );
}

export { OfferSettingsPage };
